export default __webpack_public_path__ + "static/media/mysticalbane5.0fcf38ec.png";